/**
 * Shallow equality check for objects/arrays
 * @param obj1 - The first object/array to compare
 * @param obj2 - The second object/array to compare
 * @returns True if the objects/arrays are shallowly equal, false otherwise
 */
const shallowEqual = (obj1: unknown, obj2: unknown) => {
  if (obj1 === obj2) return true;
  if (!obj1 || !obj2) return false;
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

  const keys1 = Object.keys(obj1 as Record<string, unknown>);
  const keys2 = Object.keys(obj2 as Record<string, unknown>);
  if (keys1.length !== keys2.length) return false;

  return keys1.every(
    (key) =>
      (obj1 as Record<string, unknown>)[key] ===
      (obj2 as Record<string, unknown>)[key],
  );
};

export default shallowEqual;
